import * as React from "react";
const CaroNextArrow = (props) => (
  <svg
    width={80}
    height={80}
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    className="group"
  >
    <circle
      cx={40}
      cy={40}
      r={39.5}
      stroke="#1F2022"
      className="group-hover:fill-primary"
    />
    <path
      d="M40.4476 22.3376L57.7779 39.668L40.4476 56.9983"
      stroke="#1F2022"
      className="group-hover:stroke-white"
    />
    <line
      x1={57.7773}
      y1={39.4258}
      x2={22.2235}
      y2={39.4258}
      stroke="black"
      className="group-hover:stroke-white"
    />
  </svg>
);
export default CaroNextArrow;
